import { useQuery } from '@tanstack/react-query';
import { api } from '~/services/api';

export const useGetFeaturedAttributes = (categoryId) => {
  return useQuery({
    queryKey: ['featuredAttributes', categoryId],
    queryFn: () =>
      api.get(`/category/${categoryId}/featured_attributes/`).then((res) => {
        if (res.success) {
          return res.data;
        }
        throw new Error(res.message?.error || 'Erreur lors de la récupération des attributs');
      }),
    enabled: !!categoryId,
  });
};
